"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeMediafiles = void 0;
var _kernel_store_types_1 = require("../../types");
function hasFileChanged(oldFile, newFile) {
    return (oldFile.duration !== newFile.duration ||
        oldFile.size !== newFile.size ||
        oldFile.crcHash !== newFile.crcHash);
}
function hasCrcChanged(oldFile, newFile) {
    return oldFile.crcHash ? false : oldFile.crcHash !== newFile.crcHash;
}
function mergeMediafiles(oldMediafile, newMediafile) {
    var newFile = newMediafile.files[0];
    var oldFile = oldMediafile.files.find(function (file) { return file.filename === newFile.filename; });
    var existingFiles = oldMediafile.files;
    var reasons = [];
    var changed = false;
    if (oldFile) {
        var fileChanged = hasFileChanged(oldFile, newFile);
        var crcChanged = hasCrcChanged(oldFile, newFile);
        if (fileChanged) {
            changed = true;
            if (oldFile.duration !== newFile.duration)
                reasons.push('duration');
            if (oldFile.size !== newFile.size)
                reasons.push('size');
            if (oldFile.crcHash !== newFile.crcHash)
                reasons.push('crc');
        }
        var file = __assign(__assign({}, oldMediafile), { files: __spreadArray([
                __assign(__assign({}, newFile), { cacheState: fileChanged
                        ? crcChanged
                            ? _kernel_store_types_1.EMediafileCacheState.REQUIRES_VALIDATION
                            : _kernel_store_types_1.EMediafileCacheState.NO_CACHE
                        : newFile.cacheState })
            ], __read(existingFiles.filter(function (_a) {
                var filename = _a.filename;
                return filename !== newFile.filename;
            })), false), meta: newMediafile.meta });
        return {
            mediafile: file,
            changed: changed,
            reasons: reasons,
        };
    }
    return {
        mediafile: __assign(__assign({}, oldMediafile), { files: __spreadArray([newFile], __read(existingFiles), false), meta: newMediafile.meta }),
        reasons: ["new"],
        changed: true,
    };
}
exports.mergeMediafiles = mergeMediafiles;
//# sourceMappingURL=utils.js.map